import * as React from 'react';
import * as styles from './Controller.css';
import { IAIcon } from '../../icon/Icon';

export interface IProps {
  highlightColor: string;
  visible?: boolean;
  onCrop?: () => void;
  onDublicate?: () => void;
  onDelete?: () => void;
  onDrag?: () => void;
  onDragEnd?: () => void;
}

export interface IState {
}

export class Controller extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
    }
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_controller}
        style={{
          display: this.props.visible ? "block" : "none"
        }}
      >
        {this.props.onCrop &&
          <div
            style={{
              float: "left",
              padding: 6
            }}
            onClick={() => {
              this.props.onCrop();
            }}
          >
            <IAIcon
              url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Crop/SVG/ic_fluent_crop_24_regular.svg"
              size={18}
              color={this.props.highlightColor}
            />
          </div>
        }
        {this.props.onDrag &&
          <div
            style={{
              float: "left",
              padding: 6
            }}
            draggable
            // onDrag={(event) => {
            //   event.preventDefault();
            // }}
            onDragStart={() => {
              setTimeout(() => {
                this.props.onDrag();
              }, 100);
            }}
            onDragEnd={() => {
              this.props.onDragEnd();
            }}
          >
            <IAIcon
              url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Arrow%20Move/SVG/ic_fluent_arrow_move_24_regular.svg"
              size={18}
              color={this.props.highlightColor}
            />
          </div>
        }
        {this.props.onDublicate &&
          <IAIcon
            url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Copy/SVG/ic_fluent_copy_24_regular.svg"
            size={18}
            color={this.props.highlightColor}
            style={{
              float: "left",
              padding: 6
            }}
            onClick={() => this.props.onDublicate()}
          />
        }
        {this.props.onDelete &&
          <IAIcon
            url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Delete/SVG/ic_fluent_delete_48_regular.svg"
            size={18}
            color={this.props.highlightColor}
            style={{
              float: "left",
              padding: 6
            }}
            onClick={() => {
              this.props.onDelete();
            }}
          />
        }
      </div>
    );
  }
}